import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { getName } from '~/utils/objectUtils'

import { sharedComponentColorKeys } from './_colors'

const Colors = sharedComponentColorKeys.TabButton

const TabButtonParts = ['button', 'icon', 'text'] as const

const helpers = createMultiStyleConfigHelpers(TabButtonParts)
export const TabButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    button: {
      width: 'full',
      height: '2.125rem',
      backgroundColor: Colors.Button.Background,
      borderRadius: '0.5rem',
      gap: '0.5rem',
      _hover: {
        background: Colors.Button.Hover.Background,
      },
      _active: {
        background: Colors.Button.Active.Background,
      },
    },
    icon: {
      boxSize: '1.125rem',
    },
    text: {
      textStyle: textStyleKeys.Body2,
    },
  },
})

export const useTabButtonStyle = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ TabButtonStyle }),
    props,
  ) as MultiStyleType<typeof TabButtonParts>
}
